<sw-page class="tdar-availability-request-list">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataAvailabilityRequestSW6.module.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="onRefresh">
            {{ $tc('TopdataAvailabilityRequestSW6.admin.buttonRefresh') }}
        </sw-button>
        <sw-button @click="onClear">
            {{ $tc('TopdataAvailabilityRequestSW6.admin.buttonClear') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :items="items"
            :repository="repository"
            :columns="columns"
            :isLoading="isLoading"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            identifier="tdar_availability_request"
            detail-route="tdar.availability.request.detail"
            @page-change="onPageChange"
        >
            <template #column-createdAt="{ item }">
                <sw-time-ago v-if="item.createdAt" :date="item.createdAt" />
            </template>

            <template #column-status="{ item }">
                <sw-badge :variant="statusVariant(item.status)">
                    {{ statusLabel(item.status) }}
                </sw-badge>
            </template>

            <template #actions="{ item }">
                <sw-context-menu-item @click="onOpenDetail(item)">
                    {{ $tc('global.default.view') }}
                </sw-context-menu-item>
                <sw-context-menu-item @click="setStatus(item, 'done')">
                    {{ $tc('TopdataAvailabilityRequestSW6.admin.markDone') }}
                </sw-context-menu-item>
                <sw-context-menu-item @click="setStatus(item, 'spam')">
                    {{ $tc('TopdataAvailabilityRequestSW6.admin.markSpam') }}
                </sw-context-menu-item>
                <sw-context-menu-item variant="danger" @click="onDelete(item)">
                    {{ $tc('TopdataAvailabilityRequestSW6.admin.delete') }}
                </sw-context-menu-item>
            </template>
        </sw-entity-listing>

        <sw-confirm-modal
            v-if="showDeleteModal"
            type="delete"
            :title="$tc('TopdataAvailabilityRequestSW6.admin.delete')"
            :text="$tc('TopdataAvailabilityRequestSW6.admin.deleteConfirmText')"
            @confirm="onConfirmDelete"
            @close="onCloseDeleteModal"
            @cancel="onCloseDeleteModal"
        />

        <sw-confirm-modal
            v-if="showClearModal"
            type="delete"
            :title="$tc('TopdataAvailabilityRequestSW6.admin.clearConfirmTitle')"
            :text="$tc('TopdataAvailabilityRequestSW6.admin.clearConfirmText')"
            @confirm="onConfirmClear"
            @close="onCloseClearModal"
            @cancel="onCloseClearModal"
        />
    </template>
</sw-page>
